var map = {
	"./01d.png": 47,
	"./01n.png": 48,
	"./02d.png": 49,
	"./02n.png": 50,
	"./03d.png": 51,
	"./03n.png": 52,
	"./04d.png": 53,
	"./04n.png": 54,
	"./09d.png": 55,
	"./09n.png": 56,
	"./10d.png": 57,
	"./10n.png": 58,
	"./11d.png": 59,
	"./11n.png": 60,
	"./13d.png": 61,
	"./13n.png": 62,
	"./50d.png": 63,
	"./50n.png": 64,
	"./unknown.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;